// Presentational 4-metric progress bar cell (Processed/Delivered/Opened/
// Unreached). Used in the broadcast campaign list (table cells + mobile cards).
import { cn } from '../../lib/cn';

export interface MetricBarProps {
  icon: string;
  label: string;
  pct: number;
  sub: string;
  /** Tailwind bg-* class for the fill. */
  bar: string;
}

export default function MetricBar({ icon, label, pct, sub, bar }: MetricBarProps) {
  return (
    <div className="min-w-[130px]">
      <div className="flex items-center gap-1.5 text-xs font-bold">
        <span aria-hidden>{icon}</span>
        <span>{label}</span>
      </div>
      <div className="my-1 text-[11px] text-ink-3">{sub}</div>
      <div className="h-1.5 overflow-hidden rounded-full bg-slate-200">
        <i className={cn('block h-full rounded-full', bar)} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
